import { CONSENT_COOKIE, ANALYTICS_COOKIE, CONSENT_VERSION_COOKIE } from './config'

export const COOKIE_CATEGORY = {
    NECESSARY: 'necessary',
    ANALYTICS: 'analytics',
}

export const cookieRegistry = [
    {
        name: CONSENT_COOKIE,
        category: COOKIE_CATEGORY.NECESSARY,
        expiration: '30 dní',
        purpose: 'Zapamätanie vašich cookie preferencií.',
        thirdParty: false,
    },
    {
        name: CONSENT_VERSION_COOKIE,
        category: COOKIE_CATEGORY.NECESSARY,
        expiration: '30 dní',
        purpose: 'Verzia udeleného súhlasu — pri zmene rozsahu cookies si vyžiada nový súhlas.',
        thirdParty: false,
    },
    {
        name: ANALYTICS_COOKIE,
        category: COOKIE_CATEGORY.ANALYTICS,
        expiration: '30 dní',
        purpose: 'Povolenie analytických nástrojov (Google Analytics, Facebook Pixel) a vlastnej analytiky ActivityPoint.',
        thirdParty: true,
    },
    {
        name: 'APTrackId',
        category: COOKIE_CATEGORY.ANALYTICS,
        expiration: '30 dní',
        purpose: 'Anonymný identifikátor návštevníka pre vlastnú analytiku ActivityPoint. Nie je viazaný na váš účet.',
        thirdParty: false,
    },
    {
        name: 'APTrackSession',
        category: COOKIE_CATEGORY.ANALYTICS,
        expiration: '30 minút neaktivity',
        purpose: 'Dočasný identifikátor návštevy pre meranie konverzného lievika. Po 30 minútach neaktivity zaniká.',
        thirdParty: false,
    },
]

export const cookieCategoryLabel = {
    [COOKIE_CATEGORY.NECESSARY]: 'Nevyhnutné',
    [COOKIE_CATEGORY.ANALYTICS]: 'Analytické',
}
